import { useContext } from 'react';
import { AirDropContext } from '../../utils/AirDropProvider';

export default function useFeatures() {
  const { logoTreatment } = useContext(AirDropContext);

  const isChannels = logoTreatment === 'channels';
  const isPDotCom = logoTreatment === 'p_dot_com' || logoTreatment === 'reskin';
  const isTurbo = logoTreatment === 'turbo';

  const isLegacy = logoTreatment !== 'channels'
    && logoTreatment !== 'p_dot_com'
    && logoTreatment !== 'turbo'
    && logoTreatment !== 'reskin';

  return {
    isChannels, isPDotCom, isTurbo, isLegacy,
  };
}
